import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const MonthYearSelector = ({ month, onMonthChange, year, onYearChange }) => {
  const months = [
    { value: '1', label: 'Enero' },
    { value: '2', label: 'Febrero' },
    { value: '3', label: 'Marzo' },
    { value: '4', label: 'Abril' },
    { value: '5', label: 'Mayo' },
    { value: '6', label: 'Junio' },
    { value: '7', label: 'Julio' },
    { value: '8', label: 'Agosto' },
    { value: '9', label: 'Septiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  return (
    <Row style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
      <Col>
        <Form.Group>
          <Form.Label>Mes de Corte:</Form.Label>
          <Form.Select
            value={month}
            onChange={(e) => onMonthChange(e.target.value)}
          >
            {months.map((m) => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Año:</Form.Label>
          <Form.Select
            value={year}
            onChange={(e) => onYearChange(e.target.value)}
          >
            {years.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default MonthYearSelector;
